/*
 * Copyright (C) 2023 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'

export default function Balloons(props) {
  return (
    <svg
      className="balloons"
      width="349px"
      height="334px"
      viewBox="0 0 349 334"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(-437 -162) translate(437 163)" fill="none" fillRule="evenodd">
        <path
          d="M180.7 40.62c2.135 27.732-24.138 59.646-34.342 60.441-8.929.697-41.054-26.74-43.188-54.473C101.034 18.856 117.217 2.28 138.626.633c21.41-1.65 39.938 12.255 42.073 39.988"
          fill="#E24270"
        />
        <path
          d="M180.7 40.62c2.135 27.732-24.138 59.646-34.342 60.441-8.929.697-41.054-26.74-43.188-54.473C101.034 18.856 117.217 2.28 138.626.633c21.41-1.65 39.938 12.255 42.073 39.988z"
          stroke="#BB0049"
          strokeWidth={3}
        />
        <path
          d="M146.63 104.591s-4.77 27.213 18.103 85.754c23.706 60.672.983 94.078.983 94.078"
          stroke="#808285"
          strokeWidth={2}
        />
        <path
          d="M145.778 101.55l-3.785 5.522c-.648.947.518 2.076 1.442 1.398l3.196-2.343 4.427 2.3c.843.437 1.654-.634 1.004-1.326l-5.29-5.627a.64.64 0 00-.994.076"
          fill="#E24270"
        />
        <path
          d="M145.778 101.55l-3.785 5.522c-.648.947.518 2.076 1.442 1.398l3.196-2.343 4.427 2.3c.843.437 1.654-.634 1.004-1.326l-5.29-5.627a.64.64 0 00-.994.076z"
          stroke="#BB0049"
          strokeWidth={3}
        />
        <path
          d="M241.23 91.875c-4.167 22.36-30.434 42.254-38.226 40.812-6.817-1.263-25.125-29.482-20.957-51.842 4.167-22.36 19.706-32.179 36.049-29.133 16.343 3.046 27.302 17.803 23.134 40.163"
          fill="#F7941D"
        />
        <path
          d="M241.23 91.875c-4.167 22.36-30.434 42.254-38.226 40.812-6.817-1.263-25.125-29.482-20.957-51.842 4.167-22.36 19.706-32.179 36.049-29.133 16.343 3.046 27.302 17.803 23.134 40.163z"
          stroke="#F15A29"
          strokeWidth={3}
        />
        <path
          d="M203.032 135.123s12.741 9.219-2.05 48.258c-46.37 122.379 29.76 109.992-5.868 122.9"
          stroke="#808285"
          strokeWidth={2}
        />
        <path
          d="M204.083 132.415l-3.376 4.166c-.578.713.226 1.731.993 1.26l2.655-1.63 3.216 2.25c.613.428 1.326-.375.884-.993l-3.6-5.03a.479.479 0 00-.772-.023"
          fill="#F7941D"
        />
        <path
          d="M204.083 132.415l-3.376 4.166c-.578.713.226 1.731.993 1.26l2.655-1.63 3.216 2.25c.613.428 1.326-.375.884-.993l-3.6-5.03a.479.479 0 00-.772-.023z"
          stroke="#F15A29"
          strokeWidth={2}
        />
        <path
          fill="#E24270"
          d="M8.2814 133.7689L0.0004 129.6819 4.0874 121.4009 12.3674 125.4879z"
        />
        <path
          fill="#E24270"
          d="M344.7599 213.8412L336.4799 209.7542 340.5659 201.4732 348.8469 205.5602z"
        />
        <path
          fill="#2BB673"
          d="M221.8117 202.1488L216.6977 194.4608 224.3867 189.3448 229.5007 197.0348z"
        />
        <path
          fill="#2BB673"
          d="M42.0813 242.5268L36.9673 234.8388 44.6553 229.7238 49.7693 237.4128z"
        />
        <path
          fill="#C739AE"
          d="M260.8156 126.7846L252.5346 122.6976 256.6206 114.4166 264.9016 118.5036z"
        />
        <path
          d="M64.753 141.608c4.167 22.36 30.434 42.255 38.226 40.812 6.817-1.263 25.124-29.482 20.957-51.842-4.168-22.361-19.706-32.178-36.049-29.132-16.343 3.046-27.302 17.802-23.134 40.162"
          fill="#27AAE1"
        />
        <path
          d="M64.753 141.608c4.167 22.36 30.434 42.255 38.226 40.812 6.817-1.263 25.124-29.482 20.957-51.842-4.168-22.361-19.706-32.178-36.049-29.132-16.343 3.046-27.302 17.802-23.134 40.162z"
          stroke="#1B75BC"
          strokeWidth={3}
        />
        <path
          d="M102.95 184.856s-13.489 8.516.58 41.458c23.453 54.92-12.227 43.03 2.112 105.564"
          stroke="#808285"
          strokeWidth={2}
        />
        <path
          d="M101.9 182.148l3.375 4.166c.578.713-.225 1.73-.993 1.26l-2.655-1.631-3.215 2.25c-.613.429-1.326-.373-.884-.992l3.6-5.03a.48.48 0 01.772-.023"
          fill="#27AAE1"
        />
        <path
          d="M101.9 182.148l3.375 4.166c.578.713-.225 1.73-.993 1.26l-2.655-1.631-3.215 2.25c-.613.429-1.326-.373-.884-.992l3.6-5.03a.48.48 0 01.772-.023z"
          stroke="#1B75BC"
          strokeWidth={2}
        />
      </g>
    </svg>
  )
}
